import React from 'react';

import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

const appVersion =
  typeof process.env.REACT_APP_REVISION !== 'undefined'
    ? process.env.REACT_APP_REVISION
    : 'development';

const releaseStage = process.env.REACT_APP_RELEASE_STAGE;
const bugsnagClient = bugsnag({
  apiKey: 'b9250a990575975b03a9ead2ba2899a4',
  appVersion,
  releaseStage,

  // adjust report before sending
  beforeSend: function(report) {
    // if not production, and if an error - let's just make this informative
    if (releaseStage === 'development' && report.severity === 'error') {
      report.severity = 'warning';
    }
  },

  // notify in both development and production
  notifyReleaseStages: ['development', 'production'],
});

// For some reason, bugsnag does not necessarily add the appVersion in above...
bugsnagClient.app.releaseStage = releaseStage;

bugsnagClient.use(bugsnagReact, React);

export default bugsnagClient;
